'use strict'

import { loadComponent } from './utils/load-component';
import { getUserDetails } from '../services/user';
import { getCartCount } from '../utils/cookies';

loadComponent('user-details', {
    data() {
        return {
            ViewModel: {
                Loading: true,
                LoggedIn: false,
                EmailAddress: null,
                CartCount: getCartCount(),
            },
        }
    },

    mounted() {
        getUserDetails().then(response => {
            this.ViewModel.Loading = false;
            this.ViewModel.LoggedIn = true;
            this.ViewModel.EmailAddress = response.email_address;
        }).catch(error => {
            console.error(error);
            this.ViewModel.Loading = false;
        });
    },
});
